import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOHelmet from '@/components/base/SEOHelmet';
import HeroSection from './components/HeroSection';
import HotRecommendations from './components/HotRecommendations';
import LatestUpdates from './components/LatestUpdates';
import CategoryGrid from './components/CategoryGrid';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '番木瓜漫画',
  url: 'https://www.fanmugua.com',
  description: '番木瓜漫画免费全集阅读专区，提供海量热门漫画的免费全集，支持下拉式阅读，在线免费看全集，漫画大全尽在番木瓜漫画。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.fanmugua.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

export default function Home() {
  return (
    <>
      <SEOHelmet
        title="番木瓜漫画 | 免费全集盛宴：番木瓜漫画免费全集在线阅读，番木瓜漫画免费阅读，下拉式免费漫画大全，番木瓜漫画网免费全集更新"
        description="番木瓜漫画免费全集阅读专区，提供海量热门漫画的免费全集，支持下拉式阅读，在线免费看全集，漫画大全尽在番木瓜漫画。番木瓜漫画免费全集在线阅读，番木瓜漫画免费阅读，下拉式免费漫画大全。"
        keywords="番木瓜漫画,免费全集,番木瓜漫画免费,番木瓜漫画全集,免费阅读,下拉式漫画,漫画大全,在线漫画,番木瓜漫画网,免费漫画全集"
        canonicalUrl="https://www.fanmugua.com"
        schema={homeSchema}
      />
      <ScrollToTop />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <HotRecommendations />
          <CategoryGrid />
          <LatestUpdates />
        </main>
        <Footer />
      </div>
    </>
  );
}